import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import { get_review_list } from "../../../redux/actions/reviewActions";
import StarRatingComponent from "react-star-rating-component";

const history = createHashHistory();
let isvalid = 1,
  invalidphone = "",
  disabled = false,
  submitValue = "Save",
  isLoading = "false";
class ReviewList extends Component {
  componentWillMount() {
    if (this.props.dealID) {
      this.props.get_review_list(this.props.dealID);
    }
  }

  render() {
    let reviewRow;
    if (!isEmpty(this.props.reviewList)) {
      reviewRow = this.props.reviewList.map((review, index) => (
        <div>
          <div>{review.userFirstName}</div>
          <div>{review.review}</div>
          <div>
            <StarRatingComponent
              name="rate1"
              editing={false}
              starCount={5}
              value={review.rating}
            />
          </div>
        </div>
      ));
    }
    return <div>{this.props.reviewList && reviewRow}</div>;
  }
}

ReviewList.propTypes = {
  get_review_list: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sendingData: state.reviewReducer.sendingData,
  reviewResponse: state.reviewReducer.reviewResponse,
  receivingReviewList: state.reviewReducer.receivingReviewList,
  reviewList: state.reviewReducer.reviewList
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_review_list })
)(ReviewList);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/ReviewList.js